import { createFileRoute } from '@tanstack/react-router';
import { CompanyActivityIndex } from '@/pages/super-admin/CompanyActivityIndex';

export const Route = createFileRoute('/_authenticated/super-admin/company-activity')({
	component: CompanyActivityIndex,
});
